import { render, staticRenderFns } from "./Form16CaseInformation.vue?vue&type=template&id=514af5b0&scoped=true"
import script from "./Form16CaseInformation.vue?vue&type=script&lang=ts"
export * from "./Form16CaseInformation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "514af5b0",
  null
  
)

export default component.exports